import {useTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React from 'react';
import {useScayleShippingState} from '../../scayle-state/useScayleShippingState';

export const HomeDeliveryFeePriceRow = () => {
  const {t} = useTranslation();
  const homeDeliveryFeeLabel = t('Home delivery fee');

  const {isHomeDeliveryFeeEligible, isHomeDeliverySelected, homeDeliveryFee} =
    useScayleShippingState();

  if (!isHomeDeliverySelected || !isHomeDeliveryFeeEligible) {
    return null;
  }

  return (
    <Container slot="slot_price_section_shipping-cost_sublabel">
      <span>{homeDeliveryFeeLabel}</span>
      <span>{homeDeliveryFee}</span>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 14px;
`;
